import {
    ACTION_RESET_EDITIONS_STORE,
    ACTION_SET_EDITIONS,
    type EditionsActionsTypes,
    type EditionsState,
} from '../types/editions';

const DEFAULT: EditionsState = {
    editions: [],
};

export function editions(state: EditionsState = DEFAULT, action: EditionsActionsTypes): EditionsState {
    switch (action.type) {
        case ACTION_RESET_EDITIONS_STORE:
            return DEFAULT;
        case ACTION_SET_EDITIONS:
            return { ...state, editions: action.editions };
        default:
            return { ...state };
    }
}
